import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import ButtonBase from "@material-ui/core/ButtonBase";
import Typography from "@material-ui/core/Typography";

import SUBMISSION_IMG from "../../gpap-lib/img/SUBMIT.png";
import MANAGEMENT_IMG from "../../gpap-lib/img/MANAGE.png";
import EXPERIMENT_IMG from "../../gpap-lib/img/EXPERIMENTS.png";
import FILES_IMG from "../../gpap-lib/img/FILES.png";

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
  },
  cardAction: {
    display: "block",
    textAlign: "initial",
  },
  cardMedia: {
    background: "#4575B4",
  },
});

function getImage(title) {
  switch (title) {
    case "Manage your data":
      return MANAGEMENT_IMG;
    case "Submit Data":
      return SUBMISSION_IMG;
    case "Create new Dataset":
      return EXPERIMENT_IMG;
    case "Submit Files":
      return FILES_IMG;
      
    default:
      return null;
  }
}

export default function StartCard(props) {
  const classes = useStyles();

  let { title, description, href } = props.item;

  const handleClick = (evt) => {
    window.location.href = href;
  };

  return (
    <Card className={classes.root}>
      <ButtonBase className={classes.cardAction} onClick={handleClick}>
        <CardActionArea>
          {getImage(title) !== null ? (
            <CardMedia
              className={classes.cardMedia}
              component="img"
              alt={title}
              height="140"
              image={getImage(title)}
              title={title}
            />
          ) : null}
          <CardContent>
            <Typography gutterBottom variant="h5" component="h2">
              {title}
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
              {description}
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions></CardActions>
      </ButtonBase>
    </Card>
  );
}
